import { getZonedDateParts } from './tz.js';
const MS_PER_DAY = 86_400_000;
function parseBirthdayParts(birthday) {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(birthday.date);
    if (!match)
        return null;
    return { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) };
}
function utcDateKey(utcMs) {
    const d = new Date(utcMs);
    const y = d.getUTCFullYear();
    const m = String(d.getUTCMonth() + 1).padStart(2, '0');
    const day = String(d.getUTCDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
}
/**
 * Birthdays landing within `withinDays` of `now`, computed entirely in `tz`'s wall-clock
 * calendar. `Date.UTC` normalises an out-of-range day (Feb 29 in a non-leap year rolls to
 * Mar 1), matching `calendar/birthdays.ts`'s behaviour without touching `Date#setHours`.
 */
export function upcomingBirthdaysInTz(birthdays, now, tz, withinDays = 7) {
    const today = getZonedDateParts(now, tz);
    const todayUtcMs = Date.UTC(today.year, today.month - 1, today.day);
    const out = [];
    for (const birthday of birthdays) {
        const parts = parseBirthdayParts(birthday);
        if (!parts)
            continue;
        let chosen = null;
        for (let yearOffset = 0; yearOffset <= 1; yearOffset += 1) {
            const year = today.year + yearOffset;
            const candidateUtcMs = Date.UTC(year, parts.month - 1, parts.day);
            if (candidateUtcMs >= todayUtcMs) {
                chosen = { utcMs: candidateUtcMs, year };
                break;
            }
        }
        if (!chosen)
            continue;
        const daysUntil = Math.round((chosen.utcMs - todayUtcMs) / MS_PER_DAY);
        if (daysUntil > withinDays)
            continue;
        out.push({
            birthday,
            date: utcDateKey(chosen.utcMs),
            daysUntil,
            turningAge: birthday.yearKnown ? chosen.year - parts.year : null,
        });
    }
    out.sort((a, b) => a.daysUntil - b.daysUntil || a.birthday.name.localeCompare(b.birthday.name));
    return out;
}
//# sourceMappingURL=birthdays.js.map